module.exports = __webpack_public_path__ + "static/media/yakchat-loader.263b5097.gif";